import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { DeliveryNoteItemInitialState, DeliveryNoteItemSetParams } from './delivery-note-item.actions';
import { DeliveryNoteParams } from '../models';

export interface DeliveryNoteItemStateModel {
  deliveryNoteNumber: string;
  deliveryNoteParams: DeliveryNoteParams;
}

const initialState: DeliveryNoteItemStateModel = {
  deliveryNoteNumber: null,
  deliveryNoteParams: {
    deliveryNoteNumber: null,
    sapId: null,
  },
};

@State<DeliveryNoteItemStateModel>({
  name: 'deliveryNoteItem',
  defaults: initialState,
})
@Injectable()
export class DeliveryNoteItemState {
  @Selector()
  static getState(state: DeliveryNoteItemStateModel): DeliveryNoteItemStateModel {
    return state;
  }
  @Selector()
  static getDeliveryNoteNumber(state: DeliveryNoteItemStateModel): string {
    return state.deliveryNoteNumber;
  }

  @Selector()
  static getDeliveryNoteParams(state: DeliveryNoteItemStateModel): DeliveryNoteParams {
    return state.deliveryNoteParams;
  }

  @Action(DeliveryNoteItemSetParams)
  setDeliveryNoteNumber(ctx: StateContext<DeliveryNoteItemStateModel>, { payload }: DeliveryNoteItemSetParams): void {
    ctx.patchState({ deliveryNoteParams: payload });
  }

  @Action(DeliveryNoteItemInitialState)
  setInitialState(ctx: StateContext<DeliveryNoteItemInitialState>): void {
    ctx.setState(initialState);
  }
}
